// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3934e5fc] .alert{font-size:14px}[data-v-3934e5fc] .main-subscription-buttons{margin-left:1rem;margin-right:.1rem;margin-top:1rem}[data-v-3934e5fc] .main-subscription-buttons .btn{width:160px;margin-left:0;margin-right:.5rem;margin-bottom:10px}@media(max-width: 767.98px){[data-v-3934e5fc] .main-subscription-buttons{margin-left:1rem;margin-right:1rem;margin-top:1rem}[data-v-3934e5fc] .main-subscription-buttons .btn{width:100%;margin-bottom:10px}}", ""]);
// Exports
module.exports = exports;
